import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { ControlsPosition } from "@omni/types/components/props/productSlider.props";
import { productSlider } from "@omni/ui/brand/product/productSlider/productSlider.styles";
import { cn } from "@omni/utils/styles";
import { SwiperSlide } from "swiper/react";

import { Header } from "@/components/Product/ProductSlider/components/header/header";
import { Slider } from "@/components/Product/ProductSlider/components/slider/slider";
import * as SwiperUtils from "@/utils/swiper.utils";

import { useProductSliderContext } from "../../context/productSlider.context";

const ProductSliderSkeletonComponent = () => {
    const { source, breakpointsConfig, controlsPosition } =
        useProductSliderContext();

    const productSourceIsRecent = source === ProductSliderSources.Recent;

    const {
        base,
        slider_slides,
        slider_slides_wrapper,
        slider_slides_swiperslide
    } = productSlider();

    const spaceBetween = source === ProductSliderSources.Recent ? 8 : 20;

    const variables = SwiperUtils.getLayoutCssVariables({
        layoutSettings: breakpointsConfig.layoutSettings,
        spaceBetween: spaceBetween
    });

    return (
        <div
            className={base({
                isRecent: productSourceIsRecent
            })}
        >
            <Header>
                <Header.Title />
            </Header>
            <Slider
                className={cn("tw:flex", {
                    "tw:flex-col":
                        controlsPosition !== ControlsPosition.Default,
                    "tw-flex-row": controlsPosition === ControlsPosition.Default
                })}
            >
                {controlsPosition === ControlsPosition.Default && (
                    <Slider.NavButton
                        type={"left"}
                        disabled={true}
                    />
                )}
                <div
                    className={slider_slides_wrapper({
                        className: cn("tw:flex")
                    })}
                >
                    <div
                        className={slider_slides({
                            initialized: false,
                            className: cn("tw:flex tw:overflow-hidden", {
                                "tw:mx-0!":
                                    controlsPosition !==
                                    ControlsPosition.Default
                            })
                        })}
                        style={variables}
                    >
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                        <SwiperSlide
                            className={slider_slides_swiperslide({
                                initialized: false,
                                skeleton: true,
                                className: cn("tw:aspect-2/3 tw:bg-grey-light")
                            })}
                        />
                    </div>
                </div>
                {controlsPosition === ControlsPosition.Default && (
                    <Slider.NavButton
                        type={"right"}
                        disabled={true}
                    />
                )}
                {controlsPosition !== ControlsPosition.Default && (
                    <div
                        className={cn("tw:flex tw:mt-4 tw:gap-4", {
                            "tw:self-end":
                                controlsPosition === ControlsPosition.Right,
                            "tw:self-start":
                                controlsPosition === ControlsPosition.Left
                        })}
                    >
                        <Slider.NavButton
                            type={"left"}
                            disabled={true}
                        />
                        <Slider.NavButton
                            type={"right"}
                            disabled={true}
                        />
                    </div>
                )}
            </Slider>
        </div>
    );
};

export { ProductSliderSkeletonComponent };
